import React from 'react';
import PropTypes from 'prop-types';
import * as Styles from './index.styles';

const { StyledHighlightedText, StyledTitle, StyledSubTitle } = Styles;

export const HighlightedText = ({ title, subTitle, ...otherProps }) => (
    <StyledHighlightedText {...otherProps}>
        {subTitle ? <StyledSubTitle>{subTitle}</StyledSubTitle> : null}
        <StyledTitle>{title}</StyledTitle>
    </StyledHighlightedText>
);

HighlightedText.propTypes = {
    asideColor: PropTypes.string,
    title: PropTypes.node,
    subTitle: PropTypes.node,
    large: PropTypes.bool,
    small: PropTypes.bool,
};

HighlightedText.defaultProps = {
    asideColor: '',
    title: '',
    subTitle: '',
    large: false,
    small: false,
};

HighlightedText.Styles = Styles;
